import { render, staticRenderFns } from "./003zhihuiwenlv.vue?vue&type=template&id=255603b4&scoped=true&"
import script from "./003zhihuiwenlv.vue?vue&type=script&lang=js&"
export * from "./003zhihuiwenlv.vue?vue&type=script&lang=js&"
import style0 from "./003zhihuiwenlv.vue?vue&type=style&index=0&id=255603b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255603b4",
  null
  
)

export default component.exports